module.exports = __webpack_public_path__ + "img/img15.e80f0e77.svg";